import React, { useEffect, useState } from 'react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import THead from 'components/ContentBox/Global/ReportTable/THead'
import st from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import { NavLink, useHistory } from 'react-router-dom'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import { observer } from 'mobx-react'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalization from 'hooks/useLocalization'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'

const StudentsTrialLesson = () => {
  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
  } = useTableFixedHeader()

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const [catalog, setCatalog] = useState({})
  const [filter, updateFilter] = useLocalStorageFilter()
  const history = useHistory()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const filterCnf = [
    {
      type: 'select-multi',
      label: 'Локация',
      placeholder: 'Локация',
      values: catalog?.locations,
      sort_key: 'name',
      nameState: 'location',
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
			isRequired: true,
    },
  ]

  const cols = [
    {
      name: 'Ф.И.О. студента',
    },
    { name: 'Группа' },
  ]

  const findClientData = (data) => {
    let clientData = [...data.client_names]
    clientData = clientData.map((client) => {
      let groups = data.clients.filter((item) => item.client_id === client.id)
      groups = groups.map((item) => {
        let groupData = data.group_names.find(
          (group) => group.id === item.group_id,
        )
        return { ...item, name: `${groupData.number} ${groupData.name}` }
      })
      return { ...client, groups: groups }
    })
    return clientData
  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)

      const params = {
        ...filter,
      }

      if (params.location && params.location.length > 0) {
        params.location = `[${params.location.map((item) => item)}]`
      }

      try {
        const { data } = await superAxiosRequest({
          method: 'get',
          link: 'progress_report/trial_lesson',
          params,
        })

        if (Object.keys(filter).length === 0) setCatalog(data)
        else setData(findClientData(data))
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [filter]) // Зависимость только от фильтров

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/trial_lesson') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = (data) => {
    import('xlsx-js-style').then((XLSX) => {
      const headRow = [
        {
          v: 'Ф.И.О. студента',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Группа',
          ...ExcelRowsParams.headerRowParam,
        },
      ]
      let footerRows = [
        {
          v: `Итого студентов`,
          ...ExcelRowsParams.footerRowParams.firstCell,
        },
        {
          v: `${data.length}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
      ]
      let tableData = []

      let merges = []
      let wscols = [{ wch: 50 }, { wch: 50 }]

      data.forEach((student) => {
        const groupNames = student.groups.map((group) => group.name)
        tableData.push([
          {
            v: `${student.full_name}`,
            ...ExcelRowsParams.tableRowParam.firstCell,
          },
          {
            v: groupNames.join('\n'),
            ...ExcelRowsParams.tableRowParam.cell,
          },
        ])
      })

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData, footerRows])
      ws['!cols'] = wscols
      ws['!merges'] = merges
      XLSX.utils.book_append_sheet(wb, ws, 'List 1')

      XLSX.writeFile(wb, 'Студенты с пробным уроком.xlsx')
    })
  }
  const isFilterEmpty = !filterTextValues.length

  return (
    <div>
      <ContentHeader title='Студенты с пробным уроком' />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
          isFilterEmpty={isFilterEmpty}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCnf}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>

      {isLoading ? (
        <Loader />
      ) : data && data.length > 0 ? (
        <>
          <div style={{ padding: '10px' }}>
            <ExportExcelButton data={data} downloadExcel={downloadExcel} />
          </div>
          <div className={st.tableWrapper} ref={refWrapper}>
            <div ref={refSticky} className={st.sticky}>
              <table className={st.table}>
                <THead cols={cols} />
              </table>
            </div>
            <table className={`${st.table} ${st.tbodyStriped}`}>
              <THead cols={cols} ref={refThead} />
              <tbody className={st.tbody}>
                {Array.isArray(data) && (
                  <>
                    <tr className={st.bdt}>
                      <td className={`${st.tdTotal} ${st.bdrN} ${st.ttu}`}>
                        Итого студентов
                      </td>
                      <td
                        className={`${st.tdTotal} ${st.bdlN} ${st.bdrN} ${st.textAlignCenter}`}
                      >
                        {data.length}
                      </td>
                    </tr>
                    {data.map((row) =>
                      row.groups.map((group, tdId) => (
                        <tr key={tdId} className={st.bdt}>
                          <td
                            rowSpan={row.groups.length}
                            className={`${st.tdMiddle}  ${st.fw600}`}
                            style={{
                              width: '50%',
                              background: 'white',
                              display: tdId === 0 ? '' : 'none',
                            }}
                          >
                            <div
                              className={`${st.groupDescription} ${st.medium}`}
                            >
                              <NavLink
                                to={'/account_clients/' + row.user_id}
                                target='_blank'
                              >
                                {row.full_name}
                              </NavLink>
                            </div>
                          </td>
                          <td
                            className={`${st.tdMiddle} ${st.textAlignCenter}`}
                            style={{
                              width: '50%',
                              background: tdId % 2 !== 0 ? '#f6f6f7' : 'white',
                            }}
                          >
                            <div
                              className={`${st.groupDescription} ${st.bottom}`}
                            >
                              <NavLink
                                to={`/groups/group/${group.group_id}`}
                                target='_blank'
                              >
                                {group.name}
                              </NavLink>
                            </div>
                          </td>
                        </tr>
                      )),
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <h1 className={st.noData}>Нет данных для отображения!</h1>
      )}
    </div>
  )
}

export default observer(StudentsTrialLesson)
